import { useState } from 'react';
/**
 * @returns {[number, { onScroll: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void }]}
 */
const useScrollTop = () => {
    const [scrollTop, setScrollTop] = useState(0);
    const onScroll = (event) => setScrollTop(event.target.scrollTop);
    return [scrollTop, { onScroll }];
};
export default useScrollTop;
